import api from "../utils/api";

export const Authlogin = async (data) => {
    try {
        const response = await api.post('/admin/login', data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message || error.message };
    }
}

export const Authsignup = async (data) => {
    try {
        const response = await api.post('/admin/signup', data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message || error.message };
    }
}

export const ForgotPasswordapi = async (data) => {
    try {
        const response = await api.post('/admin/forgot-password', data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message || error.message };
    }
}

export const ResetPasswordapi = async (data) => {
    try {
        const response = await api.post('/admin/reset-password', data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message || error.message };
    }
}

export const actorSendOTP = async (data) => {
    try {
        const response = await api.post('/auth/send-otp', data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message || error.message };
    }
}

export const actorVerifyOTP = async (data) => {
    try {
        const response = await api.post('/auth/verify-otp', data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error.response.data.message || error.message };
    }
}